import { render, staticRenderFns } from "./alarm.vue?vue&type=template&id=45244b9d&scoped=true&"
import script from "./alarm.vue?vue&type=script&lang=js&"
export * from "./alarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45244b9d",
  null
  
)

export default component.exports